import ServicesConfig from '@/config/ServicesConfig';
import Axios from 'axios';
import querystring from "querystring"
import ComunServices from "@/services/ComunServices";
const followRedirects = require('follow-redirects');
followRedirects.maxBodyLength = 100 * 1024 * 1024; // 100 MB
Axios.defaults.maxContentLength = Infinity

export default {
	
	payment(params) {
		
		let url = ServicesConfig.ASURAPI_SEGURIDAD.BASE_URL + '/security/token/user/' + params.userId + '/agency/24/app/SEG';
		return Axios.get(url)
			.then(res=> {
				let token = res.data;				
				if(token){
					url = ServicesConfig.BOTON_PAGOS.POST_PAYMENT;
					params.applicationCode = ServicesConfig.BOTON_PAGOS.APP_CODE;
					params.user = ServicesConfig.BOTON_PAGOS.APP_USER;
					params.password = ServicesConfig.BOTON_PAGOS.APP_PASS;

					return Axios.post(url, params,{
						headers: {
							"TOKEN": token
						}
					})
				}
			})
	},

}